import { Shops } from '@infrab4a/connect';
import { isImageProportionWithinPercentMargin } from 'src/app/utils/image-upload.util';

export interface ShopCategoryImageConstraint {
  width: number;
  height: number;
  marginPercent: number;
}

export const BANNER_CONSTRAINT: ShopCategoryImageConstraint = {
  width: 1800,
  height: 500,
  marginPercent: 10
};

export const SHOP_CATEGORY_IMAGE_ACCEPT = '.jpeg,.jpg,.png,.gif,.webp';
export const SHOP_CATEGORY_IMAGE_MAX_FILE_SIZE = 250 * 1024;

export function getShopCategoryImageConstraint(
  shop: string,
  field: string
): ShopCategoryImageConstraint | undefined {
  if (shop !== Shops.GLAMSHOP && shop !== Shops.MENSMARKET) {
    return undefined;
  }

  if (field === 'brandBanner') {
    return BANNER_CONSTRAINT;
  }

  return undefined;
}

export function getShopCategoryImageConstraintHint(
  shop: string,
  field: string
): string | undefined {
  const constraint = getShopCategoryImageConstraint(shop, field);
  if (!constraint) {
    return undefined;
  }

  return `Especificações ${constraint.width}×${constraint.height} px`;
}

export function getShopCategoryImageMarginInfo(): string {
  return '*Permitida diferença de +-10% nas dimensões especificadas';
}

export function getShopCategoryImageFormatsInfo(): string {
  return '*Formatos suportados: JPEG, JPG, PNG, GIF e WEBP';
}

export function getShopCategoryImageMaxSizeInfo(): string {
  return '*Tamanho máximo: 250kb';
}

export function canCopyShopCategoryImageToShop(
  field: string,
  targetShop: string,
  imageSize?: { width: number; height: number }
): boolean {
  const constraint = getShopCategoryImageConstraint(targetShop, field);
  if (!constraint) {
    return true;
  }

  if (!imageSize) {
    return false;
  }

  return isImageProportionWithinPercentMargin(
    imageSize.width,
    imageSize.height,
    constraint.width,
    constraint.height,
    constraint.marginPercent
  );
}
